export const FACTORY_MAP_IMAGE_URL = `${process.env.PUBLIC_URL}/img/quality-map/factory-map.svg`;

export const FACTORY_MAP_IMAGE_WIDTH = 19028;
export const FACTORY_MAP_IMAGE_HEIGHT = 12149;
export const FACTORY_MAP_BOUNDS = [
  [0, 0],
  [FACTORY_MAP_IMAGE_HEIGHT, FACTORY_MAP_IMAGE_WIDTH]
];

export function getFocusedZoom(map) {
  return Math.min(map.getMaxZoom(), map.getBoundsZoom(FACTORY_MAP_BOUNDS) + 1);
}
